// feature/fallos-grouped-view.
// Two-button toggle for Molly's /fallos page: flat table vs sections
// grouped by tipo_fallo. Inline-SVG icons match the TopBar pattern (the
// project doesn't use lucide-react). Inline styles use the same CSS
// variables (var(--accent-mint), var(--bg-subtle), etc.) the rest of
// the app uses, so no new design tokens are introduced.

import React from "react";

function ListIcon() {
  return (
    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
         strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="8" y1="6" x2="21" y2="6" />
      <line x1="8" y1="12" x2="21" y2="12" />
      <line x1="8" y1="18" x2="21" y2="18" />
      <circle cx="4" cy="6" r="1" />
      <circle cx="4" cy="12" r="1" />
      <circle cx="4" cy="18" r="1" />
    </svg>
  );
}

function GroupIcon() {
  return (
    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
         strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 6h18" />
      <path d="M6 12h15" />
      <path d="M9 18h12" />
    </svg>
  );
}

export default function FallosViewToggle({ value, onChange }) {
  return (
    <div role="tablist"
         style={{
           display: "inline-flex",
           background: "var(--bg-subtle)",
           borderRadius: 8,
           padding: 3,
           gap: 2,
         }}>
      <ToggleButton
        active={value === "flat"}
        onClick={() => onChange("flat")}
        icon={<ListIcon />}
        label="Lista plana"
      />
      <ToggleButton
        active={value === "grouped"}
        onClick={() => onChange("grouped")}
        icon={<GroupIcon />}
        label="Agrupar por tipo"
      />
    </div>
  );
}

function ToggleButton({ active, onClick, icon, label }) {
  return (
    <button type="button" role="tab" aria-selected={active}
            onClick={onClick}
            style={{
              display: "inline-flex", alignItems: "center", gap: 6,
              padding: "6px 14px",
              background: active ? "var(--bg-card)" : "transparent",
              color: active ? "var(--accent-mint)" : "var(--text-muted)",
              fontWeight: active ? 600 : 500,
              fontSize: 12,
              border: "none",
              borderRadius: 6,
              cursor: "pointer",
              boxShadow: active ? "var(--shadow-level-1)" : "none",
              transition: "background 0.15s ease, color 0.15s ease",
            }}>
      {icon}
      <span>{label}</span>
    </button>
  );
}
